import { Provider } from "react-redux";
import "./App.css";
import AddNewsBook from "./Components/AddNewsBook";
import Books from "./Components/Books";
import Filter from "./Components/Filter";
import Navbar from "./Components/Navbar";
import store from "./Redux/store";

function App() {
 return (
  <Provider store={store}>
   <Navbar />

   <main className="py-12 2xl:px-6">
    <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
     <div className="order-2 xl:-order-1">
      <Filter />
      {/* book cards */}
      <Books />
     </div>
     <div>
      {/* add new book  */}
      <AddNewsBook />
     </div>
    </div>
   </main>
  </Provider>
 );
}

export default App;
